import {fetch_retry_post, downloadFile } from "../redux/actions/ApiManager";
import { getEnv } from "../enviroment";
import { CONSTANTS } from "../common/constants/constants";

const { base } = getEnv();

// get epms list
const getEpmsList = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/list`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

// get reason for download if any
const getDownloadReason = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/getDownloadReason`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

// download epms method
const downloadEpms = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/download`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

// download epms logs
const downloadLogs = async(payload) =>  {
  try {

    let logFile = payload.key == CONSTANTS.ACCESS_LOGS ? CONSTANTS.ACCESS_LOGS_FILENAME : payload.key == CONSTANTS.REASON_LOGS ? CONSTANTS.REASON_LOGS_FILENAME : CONSTANTS.LOGIN_LOGS_FILENAME;
    let fileName = logFile + "_" + payload.startDate.replace(/-/g, "") + "_" + payload.endDate.replace(/-/g, "");
    return await downloadFile(
      `${base}/epms/downloadLogs`,
      { method: 'post', payload},
      fileName
    );
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

// view epms logs
const viewLogs = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/viewLogs`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
   
  } catch (error) {
    return { success: false, message:error.data };
  }
};

// get epms notes list
const getNotesList = async() =>  {
  try {
    let response = await fetch_retry_post(`${base}/epms/notesList`);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message:error.data };
  }
};

export const epmsService = {
  getEpmsList,
  downloadEpms,
  getDownloadReason,
  downloadLogs,
  viewLogs,
  getNotesList
};
  